'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    ParkingHistoricalDataController.$inject = ['$q', '$state', 'appConfig', 'iotService', 'localStorageService', 'measurementsService'];
    angular.module('app.admin').component('parkingHistoricalData', {
        template: '<div style="padding: 2em 0em;"><div class="container-fluid" translate-namespace="iot"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label | translate}}</a></li><li><a ui-sref="iot" translate-namespace="iot" translate>.Urban environment monitoring</a></li><li translate-namespace="iot" translate>.Analytics historical data</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-mg-3 col-lg-3"><aside class="well" style="background-color: white;"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="device" class="control-label" translate>.Devices</label><ui-select id="device" ng-init="device_name_attr = (\'device.name\' | translate)" close-on-select="true" search-enabled="true" ng-model="$ctrl.form.device" data-on-select="$ctrl.onDeviceChange($item)"><ui-select-match>{{$select.selected[device_name_attr]}}</ui-select-match><ui-select-choices data-repeat="o in ($ctrl.deviceOptions | orderBy:device_name_attr | filter: $select.search) track by o.id"><span data-ng-bind="o[device_name_attr]"></span></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="date-range" class="control-label" translate>.Date</label><p class="input-group input-group-sm"><input id="date-range" date-range-picker="t1" class="form-control input-sm" start-date="$ctrl.form.from" end-date="$ctrl.form.to" date-range-picker-options="$ctrl.uiConfig.dateRangePicker" clear-on-cancel="true" on-change="$ctrl.onDateRangeChange()"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="$ctrl.uiConfig.dateRangePicker.open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></aside></div><div class="col-xs-12 col-sm-12 col-mg-12 col-lg-9"><div class="panel panel-default" style="padding-top:1em;padding-bottom:1em;"><h4 class="title text-center">{{$ctrl.title}}</h4><div class="subtitle text-center">{{$ctrl.subtitle}}</div><nvd3 class="nvd3-chart" options="$ctrl.uiConfig.lineChart.options" config="$ctrl.uiConfig.lineChart.config" api="$ctrl.chartApi" data="$ctrl.chart"></nvd3></div></div></div></div></div>',
        controller: ParkingHistoricalDataController,
        controllerAs: '$ctrl'
    });

    function ParkingHistoricalDataController($q, $state, appConfig, iotService, localStorageService, measurementsService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            $ctrl.form = new FormModel();
            $ctrl.uiConfig = new UiConfig($ctrl.form, measurementsService);

            $ctrl.chartApi;

            $q.all({
                parkingDevices: iotService.getParkingDevices()
            }).then(function (r) {
                $ctrl.deviceOptions = r.parkingDevices;

                $ctrl.form.device = $ctrl.deviceOptions[0];
            });
        };

        /**
         * 
         */
        $ctrl.onDeviceChange = function (device) {
            $ctrl.updateChart();
        };

        $ctrl.onDateRangeChange = function () {
            $ctrl.updateChart();
        };

        $ctrl.updateChart = function () {
            measurementsService.getParkingRawMeasurements($ctrl.form.device, $ctrl.form.from, $ctrl.form.to).then(function (r) {
                var data = { 'x': [], 'y': [], 'z': [], 'presence': [] };
                $ctrl.chartApi.refresh();
                $ctrl.chart = [];
                angular.forEach(r, function (entry) {
                    data.x.push({ at: entry.created_at, value: entry.x_mf });
                    data.y.push({ at: entry.created_at, value: entry.y_mf });
                    data.z.push({ at: entry.created_at, value: entry.z_mf });
                    data.presence.push({ at: entry.created_at, value: entry.presence });
                });

                $ctrl.chartApi.refresh();
                $ctrl.chart.push({ key: 'X', values: data.x, yAxis: 1, type: 'line', color: '#ff0000' });
                $ctrl.chart.push({ key: 'Y', values: data.y, yAxis: 1, type: 'line', color: '#00ff00' });
                $ctrl.chart.push({ key: 'Z', values: data.z, yAxis: 1, type: 'line', color: '#0000ff' });
                $ctrl.chart.push({ key: 'Occupied', values: data.presence, yAxis: 2, type: 'line', color: '#ffa500' });
                $ctrl.chartApi.clearElement();
            });
        };
    }

    /**
     * 
     */

    var FormModel = function FormModel() {
        _classCallCheck(this, FormModel);

        this.device = undefined;
        this.modality = undefined;
        this.from = moment().add(-1, 'week').startOf();
        this.to = moment().endOf();
        this.showOutOfRange = true;
    };

    /**
     * 
     */


    var UiConfig = function () {
        function UiConfig(form, measurementsService) {
            var _locale;

            _classCallCheck(this, UiConfig);

            this.dataRangePicker = {
                locale: (_locale = {
                    format: 'DD/MM/YYYY'
                }, _defineProperty(_locale, 'format', 'shortDate'), _defineProperty(_locale, 'separator', ' - '), _locale)
            };

            this.lineChart = new MultiChartConfig(form, measurementsService);
        }

        _createClass(UiConfig, [{
            key: 'setTranslations',
            value: function setTranslations(i18n) {
                this.lineChart.setTranslations(i18n);
            }
        }]);

        return UiConfig;
    }();

    /**
     * 
     */


    var MultiChartConfig = function () {
        function MultiChartConfig(form, measurementsService) {
            _classCallCheck(this, MultiChartConfig);

            this.form = form;
            this.toBeaufort = measurementsService.toBeaufort;
            this.toCompass = measurementsService.toCompass;

            this.config = {
                deepWatchOptions: true,
                deepWatchData: true,
                deepWatchDataDepth: 2
            };

            this.options = {
                title: { enable: false },
                subtitle: { enable: false },

                chart: {

                    id: 'multiChart',
                    type: 'multiChart',
                    useInteractiveGuideline: true,

                    height: 550,
                    duration: 250,

                    // margin: { top: 20, right: 60, bottom: 60, left: 80 },
                    // legend: { margin: { top: 10, right: 0, bottom: 10, left: 0 } },

                    defined: function defined(d, i) {
                        return typeof d.value != 'undefined';
                    },

                    x: function x(d) {
                        return d.at;
                    },
                    y: function y(d) {
                        return d.value;
                    },

                    forceY: [],
                    xScale: d3.time.scale(),
                    focus: { xScale: d3.time.scale() },

                    xAxis: { tickFormat: this.timeFormatter() },
                    x2Axis: { tickFormat: this.timeFormatter() },
                    yAxis1: { tickFormat: d3.format(',.0f') },

                    interpolate: 'step-after',

                    interactiveLayer: {
                        tooltip: {
                            headerFormatter: this.tooltipHeaderFormatter()
                            // valueFormatter: this.tooltipValueFormatter(),
                        }
                    }
                }
            };
        }

        _createClass(MultiChartConfig, [{
            key: 'timeFormatter',
            value: function timeFormatter() {
                return function (d) {
                    return d3.currentLocale.timeFormat.multi([['%d/%m/%Y %H:%M', function (d) {
                        return true;
                    }]])(new Date(d));
                };
            }
        }, {
            key: 'tooltipHeaderFormatter',
            value: function tooltipHeaderFormatter() {
                return d3.currentLocale.timeFormat.multi([['%d/%m/%Y %H:%M', function (d) {
                    return true;
                }]]);
            }
        }]);

        return MultiChartConfig;
    }();
})();